import { createMelaClient } from '@mela/api-client';
import { getAccessToken, supabase, supabaseConfigured } from './supabase';

const baseUrl = (import.meta.env.VITE_MELA_API_URL ?? '').trim();
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim() || undefined;

export const apiClient = createMelaClient({
  baseUrl,
  anonKey,
  getAccessToken,
  onAuthError: () => {
    if (supabaseConfigured) {
      // Token rejected by API — wipe the local session so UI prompts re-login.
      supabase.auth.signOut().catch(() => {});
    }
  },
});

export const isMockApi = !baseUrl;
